import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { SpinnerService } from "src/utilities/services/SpinnerService";

@Component({
  selector: 'app-global-spinner',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div *ngIf="visible$ | async" class="spinner-overlay">
      <div class="spinner"></div>
    </div>
  `,
  styles: [`
    .spinner-overlay {
      position: fixed;
      top: 0; left: 0;
      width: 100vw;
      height: 100vh;
      background: rgba(0, 0, 0, 0.3);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 9999;
    }
    .spinner {
      border: 6px solid #f3f3f3;
      border-top: 6px solid var(--primary-color); /* Color Ionic */
      border-radius: 50%;
      width: 40px;
      height: 40px;
      animation: spin 1s linear infinite;
    }
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  `]
})
export class GlobalSpinnerComponent {
  visible$ = this.spinnerService.visible$;
  constructor(private spinnerService: SpinnerService) {}
}
